import * as p from '@clack/prompts'
import type { SchemaPromptContext } from '@cli-types/next-adapter/commands.js'
import { cancel } from './cancel.js'

export async function promptConfirm(
  context: SchemaPromptContext,
  message: string,
  initialValue = true
): Promise<boolean> {
  const confirmed = await p.confirm({ message, initialValue })
  if (p.isCancel(confirmed)) {
    cancel(context)
  }
  return Boolean(confirmed)
}
